 import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Container, Grid, Card, CardContent, Rating, Avatar } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AnimatedSection from '../components/AnimatedSection';
import "@fontsource/playfair-display";

const aboutBanner = '/assets/bridal_banner.jpeg';

const values = [
  {
    title: 'Excellence',
    desc: 'We deliver premium quality services with attention to every detail',
  },
  {
    title: 'Quality',
    desc: 'Your comfort and satisfaction are our top priorities',
  },
  {
    title: 'Artistry',
    desc: 'We blend artistry with expertise for stunning results',
  },
  {
    title: 'Luxury',
    desc: 'A premium experience in a sophisticated ambiance',
  },
];

const contactInfo = [
  {
    icon: <LocationOnIcon sx={{ fontSize: '2.5rem', color: '#FF0099', mb: 1 }} />,
    title: 'Asilmetta Branch',
    desc: (
      <>
        Opp. Bombay Gaslight Stores
        <br />
        Asilmetta Junction, Visakhapatnam
        <br />
        <Box 
          component="a" 
          href="tel:8977626223" 
          sx={{ color: '#FF0099', fontWeight: 700, textDecoration: 'none', display: 'inline-block', mt: 1, '&:hover': { textDecoration: 'underline' } }}
        >
          +91 89776 26223
        </Box>
        <br />
        <Box 
          component="a" 
          href="https://maps.app.goo.gl/7r93iVAVRdYumT5n9" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{ color: '#666', fontSize: '0.85rem', textDecoration: 'underline', display: 'inline-block', mt: 0.5, '&:hover': { color: '#FF0099' } }}
        >
          View on Google Maps
        </Box>
      </>
    ),
  },
  {
    icon: <LocationOnIcon sx={{ fontSize: '2.5rem', color: '#FF0099', mb: 1 }} />,
    title: 'Madhurawada Branch',
    desc: (
      <>
        Madhurawada
        <br />
        Visakhapatnam
        <br />
        <Box sx={{ mt: 1 }}>
          <Box 
            component="a" 
            href="tel:9949788891" 
            sx={{ color: '#FF0099', fontWeight: 700, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            +91 99497 88891
          </Box>
          {' | '}
          <Box 
            component="a" 
            href="tel:9949388891" 
            sx={{ color: '#FF0099', fontWeight: 700, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            +91 99493 88891
          </Box>
        </Box>
        <Box 
          component="a" 
          href="https://share.google/V5E9UhEwGzjXTvJ0N" 
          target="_blank" 
          rel="noopener noreferrer"
          sx={{ color: '#666', fontSize: '0.85rem', textDecoration: 'underline', display: 'inline-block', mt: 0.5, '&:hover': { color: '#FF0099' } }}
        >
          View on Google Maps
        </Box>
      </>
    ),
  },
  {
    icon: <AccessTimeIcon sx={{ fontSize: '2.5rem', color: '#FF0099', mb: 1 }} />,
    title: 'Working Hours',
    desc: (
      <>
        Monday - Sunday
        <br />
        9:00AM - 9:00PM
        <br />
        <Typography component="span" sx={{ color: '#888', fontSize: '0.85rem', display: 'inline-block', mt: 1 }}>
          Open all 7 days across both branches
        </Typography>
      </>
    ),
  },
];

const testimonials = [
  {
    name: 'Chiriki Satyavathi',
    stars: 5,
    text: `Really had a great experience. Got my first haircut was really nervous but the service was so incredible. Kalyan bro was friendly and interactive Much satisfied with the service Would highly recommenAbsolutely love the bridal package! The team made me feel like a queen on my special day.Highly recommend Splash for any bride- to - be.`,
  },
  {
    name: 'Ramya Reddy',
    stars: 5,
    text: "Really happy with the service. Mounika was kind and patient, and they made sure I was comfortable throughout. The results turned out exactly how I wanted. Would definitely recommend this place to my friends and family.",
  },
  {
    name: 'Usha Kiranmai',
    stars: 5,
    text: "I had a very good experience at this parlour. The beautician(Sashikala garu❤️) did an excellent job and was very professional, polite, and patient. The service was neat and I am really happy with the results. Highly recommende",
  },
  {
    name: 'Kavitha Rani',
    stars: 5,
    text: "I'm Kavitha... Today I visited splash Beauty lounge.. The service was extraordinary and given good service by Ms. Vijaya garu... Really good And Really I want to visit again and sure Thank you",
  },
  {
    name: 'Hemareddy Sangati',
    stars: 5,
    text: "I visted first tym, but the service is amazing. For me yamuna mam took over everything. Its great thank you so much..",
  },
  {
    name: 'Danga Anu',
    stars: 5,
    text: "I have a fantastic experience with splash beauty lounge 4999 PKG highly recommend mounica Head massage and hair cuts done by Ashok thank you splash",
  },
];

export default function AboutPage() {
  return (
    <Box>
      <Helmet>
        <title>About Splash Beauty Lounge | Top Unisex Salon in Vizag</title>
        <meta name="description" content="Learn about Splash Beauty Lounge, Vizag's trusted unisex salon with expert professionals offering premium beauty, hair and skincare services." />
        <meta name="keywords" content="about Splash Beauty Lounge, best salon Asilmetta, best salon Madhurawada, beauty experts Vizag, hair stylists Vizag, skincare specialists Vizag, salon professionals Vizag" />
      </Helmet>
      {/* Hero Section */}
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${aboutBanner})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          py: { xs: 8, md: 12 },
          textAlign: 'center',
          color: '#fff',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1, px: 3 }}>
          <Typography
            variant="h2"
            sx={{
              color: '#fff',
              fontFamily: '"Playfair Display", serif',
              fontSize: { xs: '2.5rem', md: '4rem' },
              mb: 2,
              textShadow: '0 2px 15px rgba(0,0,0,0.5)',
            }}
          >
            About Splash Beauty Lounge
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Lato", sans-serif',
              color: 'rgba(255,255,255,0.95)',
              fontSize: { xs: '1rem', md: '1.2rem' },
              maxWidth: 600,
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            Your destination for luxury beauty and wellness in Visakhapatnam
          </Typography>
        </Box>
      </Box>


      {/* Story Section */}
      <Container maxWidth="md" sx={{ py: 8 }}>
        <AnimatedSection>
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Playfair Display", serif',
              color: '#FF0099',
              textAlign: 'center',
              mb: 4,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            Our Story
          </Typography>
          <Typography
            sx={{
              fontSize: '1rem',
              lineHeight: 1.8,
              color: '#555',
              mb: 3,
              textAlign: 'center',
            }}
          >
            Splash Beauty Lounge is Visakhapatnam's premier destination for luxury beauty and wellness. We have built our reputation on delivering exceptional services across a comprehensive range of beauty treatments - from hair styling and coloring to bridal makeup, skincare, nail care, and premium men's grooming.
          </Typography>
          <Typography
            sx={{
              fontSize: '1rem',
              lineHeight: 1.8,
              color: '#555',
              textAlign: 'center',
            }}
          >
            With expert stylists trained in the latest beauty trends, premium products from top international brands like L'Oreal and Schwarzkopf, and a commitment to luxury experience, we ensure every client leaves our salon feeling pampered and confident. We combine traditional beauty techniques with modern innovations to deliver personalized experiences that exceed expectations.
          </Typography>
        </AnimatedSection>
      </Container>

      {/* Core Values Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <AnimatedSection>
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Playfair Display", serif',
              color: '#FF0099',
              textAlign: 'center',
              mb: 6,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            Our Values
          </Typography>
        </AnimatedSection>
        <Grid container spacing={3} sx={{ position: 'relative', zIndex: 1 }}>
          {values.map((value, idx) => (
            <Grid item xs={12} sm={6} md={3} key={idx} sx={{ display: 'flex' }}>
              <AnimatedSection delay={idx * 0.1} sx={{ display: 'flex', width: '100%' }}>
                <Card
                  elevation={1}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 3,
                    border: '1px solid #eee',
                    backgroundColor: '#fff',
                    textAlign: 'center',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 10px 30px rgba(255, 0, 153, 0.1)',
                    },
                  }}
                >
                  <CardContent sx={{ p: { xs: 3, md: 2, lg: 4 }, flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography
                      sx={{
                        fontFamily: '"Playfair Display", serif',
                        fontSize: '1.3rem',
                        fontWeight: 700,
                        color: '#FF0099',
                        mb: 2,
                      }}
                    >
                      {value.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '0.95rem',
                        color: '#666',
                        lineHeight: 1.6,
                      }}
                    >
                      {value.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Testimonials Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <AnimatedSection>
          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Typography
              sx={{
                fontFamily: '"Lato", sans-serif',
                fontSize: '0.75rem',
                color: '#FF0099',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
                mb: 1,
              }}
            >
              TESTIMONIALS
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontFamily: '"Playfair Display", serif',
                color: '#1a1a1a',
                fontSize: { xs: '1.8rem', md: '2.2rem' },
                fontWeight: 700,
              }}
            >
              What Our Clients Say
            </Typography>
          </Box>
        </AnimatedSection>
        <Grid container spacing={3}>
          {testimonials.map((t, idx) => (
            <Grid item xs={12} sm={6} md={4} key={t.name} sx={{ display: 'flex' }}>
              <AnimatedSection delay={idx * 0.08} sx={{ display: 'flex', width: '100%' }}>
                <Box
                  sx={{
                    border: '1px solid #f0f0f0',
                    borderRadius: 3,
                    p: 3,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#fff',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 24px rgba(255, 0, 153, 0.1)',
                      borderColor: '#FF0099',
                    },
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
                    <Rating
                      value={t.stars}
                      readOnly
                      size="small"
                      sx={{ color: '#FF0099' }}
                      icon={<StarIcon fontSize="inherit" />}
                      emptyIcon={<StarIcon fontSize="inherit" />}
                    />
                    <Typography sx={{ fontFamily: '"Playfair Display", serif', fontSize: '1.8rem', color: '#f0c2df', lineHeight: 1 }}>
                      “
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: '"Lato", sans-serif',
                      fontSize: '0.86rem',
                      color: '#555',
                      lineHeight: 1.7,
                      mb: 2.5,
                      fontStyle: 'italic',
                      flexGrow: 1,
                    }}
                  >
                    "{t.text}"
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 'auto', pt: 1.5, borderTop: '1px solid #f8f8f8' }}>
                    <Avatar
                      sx={{
                        width: 36,
                        height: 36,
                        backgroundColor: '#FF0099',
                        fontSize: '0.9rem',
                        fontFamily: '"Lato", sans-serif',
                        fontWeight: 700,
                      }}
                    >
                      {t.name[0]}
                    </Avatar>
                    <Typography
                      sx={{
                        fontFamily: '"Lato", sans-serif',
                        fontWeight: 700,
                        fontSize: '0.88rem',
                        color: '#1a1a1a',
                      }}
                    >
                      {t.name}
                    </Typography>
                  </Box>
                </Box>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Contact Information */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <AnimatedSection>
          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Playfair Display", serif',
              color: '#FF0099',
              textAlign: 'center',
              mb: 6,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            Visit Us Today
          </Typography>
        </AnimatedSection>
        <Grid container spacing={3} justifyContent="center">
          {contactInfo.map((info, idx) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={idx} sx={{ display: 'flex' }}>
              <AnimatedSection delay={idx * 0.1} sx={{ display: 'flex', width: '100%' }}>
                <Card
                  elevation={1}
                  sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: 3,
                    border: '1px solid #eee',
                    backgroundColor: '#fff',
                    textAlign: 'center',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 10px 30px rgba(255, 0, 153, 0.1)',
                    },
                  }}
                >
                  <CardContent sx={{ p: 4, flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    {info.icon}
                    <Typography
                      sx={{
                        fontFamily: '"Playfair Display", serif',
                        fontSize: '1.3rem',
                        fontWeight: 700,
                        color: '#1a1a1a',
                        mb: 2,
                      }}
                    >
                      {info.title}
                    </Typography>
                    <Typography
                      component="div"
                      sx={{
                        fontSize: '0.95rem',
                        color: '#666',
                        lineHeight: 1.6
                      }}
                    >
                      {info.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </AnimatedSection>
            </Grid>
          ))}
        </Grid>
      </Container>

    </Box>
  );
}
